<template>
	<v-container class="mt-12 pt-8" style="background:#fafafa;">
		<v-row style="background:#fafafa;">
			<v-col cols="12" class="pa-0">
				<v-row class="py-1 px-5">
					<v-col cols="12" md="12" LeadsPannel>
						<v-row>
							<v-col cols="12" LEADSPANEL>
								<v-card :loading="loading">
									<v-card-text class="py-0">
										<v-row class="align-center">
											<v-col cols="12">
												<v-row class="align-center">
													<v-col cols="2" class="text-center" TITLE>
														<v-icon size="40" color="secondary">description</v-icon>
													</v-col>
													<v-col cols="10" TITLE>
														<div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">صفحات
															الخدمة</div>
														<div :class="`${arabic ? 'arFont' : 'enFont'} grey--text`">إنشاء,
															تعديل وحذف صفحات الخدمة
														</div>
													</v-col>
												</v-row>
											</v-col>
											<v-col cols="12" md="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
												<Paging :resourceSettings="resourceSettings" :resource="resource" @createResource="createResource"
													@loadResource="loadResource" @pageByNumber="pageByNumber" />
											</v-col>
											<v-col cols="12" class=" py-0">
												<v-row>
													<v-col cols="12" v-for="(page, index) in resource.data">
														<v-card>
															<v-card-text :class="arabic ? `arFont` : 'enFont'">
																<v-row align="center">
																	<v-col cols="12" sm="6" md="3">
																		<strong>
																			<small>عنوان الصفحة</small>
																		</strong>
																		<br>
																		<span>{{ page.title }}</span>
																	</v-col>
																	<v-col cols="12" sm="6" md="3">
																		<strong>
																			<small>عنوان القائمة</small>
																		</strong>
																		<br>
																		<span>{{ page.title }}</span>
																	</v-col>
																	<v-col cols="12" sm="6" md="2">
																		<strong>
																			<small>الصورة</small>
																		</strong>
																		<br>
																		<span class="d-block overflow-hidden text-truncate">{{
																			page.image }}</span>
																		<div class="d-flex justify-content-center w-100 align-items-center">
																			<v-btn v-clipboard:copy="page.image" color="success" x-small>
																				<v-icon size="small" class="ml-1">content_copy</v-icon>
																				نسخ
																			</v-btn>
																			<v-btn :href="page.image" target="_blank" class="mr-2" color="blue" dark x-small>
																				<v-icon size="small" class="ml-1">open_in_new</v-icon>
																				فتح
																			</v-btn>
																		</div>
																	</v-col>
																	<v-col cols="12" sm="6" md="2">
																		<strong>
																			<small>رابط التواصل</small>
																		</strong>
																		<br>
																		<span class="d-block overflow-hidden text-truncate">{{
																			page.contact_url }}</span>
																		<div class="d-flex justify-content-center w-100 align-items-center">
																			<v-btn v-clipboard:copy="page.contact_url" color="success" x-small>
																				<v-icon size="small" class="ml-1">content_copy</v-icon>
																				نسخ
																			</v-btn>
																			<v-btn :href="page.contact_url" target="_blank" class="mr-2" color="blue" dark
																				x-small>
																				<v-icon size="small" class="ml-1">open_in_new</v-icon>
																				فتح
																			</v-btn>
																		</div>
																	</v-col>
																	<v-col cols="12" sm="6" md="2">
																		<v-btn color="indigo" dark small @click.prevent="editPage(page)">تعديل</v-btn>
																		<v-btn class="mr-2" color="error" small @click.prevent="deletePage(page)">حذف</v-btn>
																	</v-col>
																</v-row>
															</v-card-text>
														</v-card>
													</v-col>
												</v-row>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import Paging from '../components/Paging.vue';

export default {
	components: {
		Paging
	},
	data() {
		return {
			loading: false,
			resourceSettings: {
				createResource: true,
				resourceName: null,
				search: false,
				create: false,
				pagination: true,
			},
			resource: {}
		}
	},
	methods: {
		editPage(page) {
			this.$router.push(`/service-pages/${page.id}/edit`)
		},
		async deletePage(page) {
			this.loading = true
			this.$store.dispatch('deleteResource', { resource: `/service-pages/${page.id}` })
			this.loading = false

			await this.loadResource()
		},
		clipboardSuccessHandler({ value, event }) {
			this.$emit('clipboardSuccessHandler', { value, event });
		},
		async loadResource(page = 1) {
			this.loading = true
			this.resource = await this.$store.dispatch('getResource', { resource: `/service-pages?page=${page}` })
			this.loading = false
		},
		async pageByNumber(page) {
			await this.loadResource(page)
		},
		createResource() {
			this.$router.push('/service-pages/create')
		}
	},
	computed: {
		i18n() {
			return this.$store.state.i18n[this.$store.state.language]
		},
		arabic() {
			if (this.$store.state.language == 'ar') return true
		},
	},
	async mounted(page = 1) {
		await this.loadResource()
	}
}
</script>